var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: 16,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86.724a.5.5 0 0 1 .923-.382l.479 1.154a.5.5 0 1 1-.924.383L4.859.724ZM1.34 4.784l1.155.478a.5.5 0 1 0 .383-.924l-1.155-.479a.5.5 0 1 0-.383.924Zm11.972.516c.065 0 .13-.013.19-.038l1.155-.479a.5.5 0 1 0-.382-.924l-1.155.479a.5.5 0 0 0 .191.962Zm-3.304-3.15a.5.5 0 0 0 .653-.27l.479-1.156a.5.5 0 0 0-.924-.382l-.479 1.154a.5.5 0 0 0 .271.654ZM15 7.5h-2.78a4.25 4.25 0 1 0-8.44 0H1a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1ZM13 10H3a.5.5 0 0 0 0 1h10a.5.5 0 1 0 0-1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorning);
export default __webpack_public_path__ + "static/media/morning.9517906903bebd76473b4866a8869038.svg";
export { ForwardRef as ReactComponent };